import api from '.';
import { PaginationProps } from '../common/interface/pagination';

interface GetInstrumentListGroupParams extends PaginationProps {}

interface CreateInstrumentListGroup {
  name: string;
  instrumentLists?: { name: string }[];
}

interface UpdateInstrumentListGroup
  extends Omit<CreateInstrumentListGroup, 'instrumentLists'> {
  id: number;
}

export async function getInstrumentListGroups() {
  const { data } = await api.get('/instrument-list-groups');
  return data;
}

export async function getInstrumentListGroupsMasterData(
  params: GetInstrumentListGroupParams
) {
  const { data } = await api.get('/instrument-list-groups/master-data', {
    params
  });
  return data;
}

export async function getInstrumentListGroup(id: number) {
  const { data } = await api.get(`/instrument-list-groups/${id}`);
  return data;
}

export async function createInstrumentListGroup(
  createInstrumentListGroup: CreateInstrumentListGroup
) {
  const { data } = await api.post(
    '/instrument-list-groups',
    createInstrumentListGroup
  );
  return data;
}

export async function updateInstrumentListGroup(
  updateInstrumentListGroup: UpdateInstrumentListGroup
) {
  const { data } = await api.put(
    `/instrument-list-groups/${updateInstrumentListGroup.id}`,
    updateInstrumentListGroup
  );
  return data;
}

export function deleteInstrumentListGroup(id: number) {
  return api.delete(`/instrument-list-groups/${id}`);
}
